import { Component, OnInit } from '@angular/core';
import { RouteNames } from '../../../../shared/routing/app-routing.constants';
import { Router } from '@angular/router';
import { AgAppConfigService } from '@ag/vc.ag-core/settings';

@Component({
  selector: 'app-login-agnostic',
  templateUrl: './login-agnostic.component.html',
  styleUrls: ['./login-agnostic.component.scss']
})
export class LoginAgnosticComponent implements OnInit {
  constructor(private readonly router: Router) { }

  ngOnInit(): void {
  }
  navigate(flow: string): void {
    const redirectUri = AgAppConfigService.get<string>('redirectUri');
    const params = new URLSearchParams({ lang: 'fr', distcha: '1', partcd: '38839', partcdRange: '4' });
    if (flow === 'login') {
      this.router.navigate(['/' + RouteNames.authentication + '/' + RouteNames.login])
    } else {
      window.location.href = `${redirectUri}?${params.toString()}`;
    }
  }
}